"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertScheduledMail = exports.convertScheduledMailAttachment = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
exports.convertScheduledMailAttachment = function (scheduledMailAttachment) {
    if (!api_model_bear_1.GdcScheduledMail.isKpiDashboardAttachment(scheduledMailAttachment)) {
        throw new sdk_backend_spi_1.NotSupported("Cannot convert attachment - only dashboard attachments are currently supported.");
    }
    var _a = scheduledMailAttachment.kpiDashboardAttachment, format = _a.format, uri = _a.uri, filterContext = _a.filterContext;
    return {
        dashboard: sdk_model_1.uriRef(uri),
        format: format,
        filterContext: filterContext ? sdk_model_1.uriRef(filterContext) : undefined,
    };
};
exports.convertScheduledMail = function (scheduledMail) {
    var _a = scheduledMail.scheduledMail, _b = _a.content, attachments = _b.attachments, body = _b.body, subject = _b.subject, to = _b.to, when = _b.when, bcc = _b.bcc, lastSuccessfull = _b.lastSuccessfull, unsubscribed = _b.unsubscribed, _c = _a.meta, uri = _c.uri, identifier = _c.identifier, title = _c.title, summary = _c.summary, unlisted = _c.unlisted;
    return tslib_1.__assign(tslib_1.__assign({ title: title, description: summary }, (uri
        ? {
            ref: sdk_model_1.uriRef(uri),
            identifier: identifier,
            uri: uri,
        }
        : {})), { body: body,
        subject: subject,
        to: to, when: {
            startDate: when.startDate,
            endDate: when.endDate,
            timeZone: when.timeZone,
            recurrence: when.recurrency,
        }, bcc: bcc, lastSuccessful: lastSuccessfull, unsubscribed: unsubscribed, attachments: attachments.map(exports.convertScheduledMailAttachment), unlisted: !!unlisted });
};
//# sourceMappingURL=scheduledMails.js.map